import React from 'react'
import { useTranslation } from 'react-i18next'

import Field from '../../../../../../../components/Form/Field'
import FieldLabelWrapper from '../../../../../../../features/components/Form/FieldLabelWrapper'

import { AGE_MAX, AGE_MIN } from '../../../../../fields'
import { ageYearsList } from '../../../../../../../constants/selectLists/ageYearsList'

import useAudienceSectionStyles from '../styles'

const AgeContent = ({ formik }) => {
  const audienceClasses = useAudienceSectionStyles()

  const { t } = useTranslation()

  const { values } = formik

  const minYearsList = ageYearsList.filter(year => year.value < values[AGE_MAX])
  const maxYearsList = ageYearsList.filter(year => year.value > values[AGE_MIN])

  if (values[AGE_MIN] < 18) {
    // in some cases we can get age that less then minimum supported "18" by our platform
    minYearsList.unshift({
      value: values[AGE_MIN],
      label: `${values[AGE_MIN]}`
    })
  }

  if (values[AGE_MAX] < 18) {
    maxYearsList.unshift({
      value: values[AGE_MAX],
      label: `${values[AGE_MAX]}`
    })
  }

  return (
    <FieldLabelWrapper label={t('Age')}>
      <div className={audienceClasses.sectionAgePickers}>
        <Field
          formik={formik}
          name={AGE_MIN}
          placeholder={t('Minimum Age')}
          options={minYearsList}
          isSearchable={false}
        />
        <Field
          formik={formik}
          name={AGE_MAX}
          placeholder={t('Maximum Age')}
          options={maxYearsList}
          isSearchable={false}
        />
      </div>
    </FieldLabelWrapper>
  )
}

export default AgeContent
